import React from 'react';
import { Box, SimpleGrid, Text, Stat, StatLabel, StatNumber, StatHelpText, StatArrow, Icon, HStack, Skeleton, Wrap, WrapItem } from '@chakra-ui/react';
import { FiClock, FiHelpCircle, FiCalendar, FiMoon, FiSun, FiBriefcase } from 'react-icons/fi';

const formatarMinutos = (minutos) => {
    if (minutos === null || minutos === undefined) return 'N/A';
    if (minutos < 60) return `${minutos} min`;
    const horas = Math.floor(minutos / 60);
    const mins = minutos % 60;
    return `${horas}h ${mins}min`;
};

const MetricaCard = ({ title, data }) => {
    const { total_unanswered, total_today, response_time_data } = data;

    return (
        <Box borderWidth="1px" borderRadius="lg" p={4} boxShadow="sm">
            <Text fontSize="md" fontWeight="bold" mb={3}>{title}</Text>

            <SimpleGrid columns={2} spacing={4} mb={3} borderBottomWidth="1px" pb={3}>
                <Stat size="sm">
                    <StatLabel display="flex" alignItems="center" fontSize="sm"><Icon as={FiHelpCircle} mr={1.5} /> Sem Resposta</StatLabel>
                    <StatNumber fontSize="xl">{total_unanswered}</StatNumber>
                </Stat>
                <Stat size="sm">
                    <StatLabel display="flex" alignItems="center" fontSize="sm"><Icon as={FiCalendar} mr={1.5} /> Hoje</StatLabel>
                    <StatNumber fontSize="xl">{total_today}</StatNumber>
                </Stat>
            </SimpleGrid>

            {response_time_data ? (
                <>
                    <Text fontSize="sm" fontWeight="semibold" mb={2}>
                        Tempo médio de resposta
                    </Text>
                    <Wrap spacingX={4} spacingY={1}>
                        <WrapItem>
                            <Stat size="xs">
                                <StatLabel display="flex" alignItems="center" fontSize="xs">
                                    <Icon as={FiClock} mr={1} /> Total
                                </StatLabel>
                                <StatNumber fontSize="sm">
                                    {formatarMinutos(response_time_data.total?.response_time)}
                                </StatNumber>
                            </Stat>
                        </WrapItem>
                        <WrapItem>
                            <Stat size="xs">
                                <StatLabel display="flex" alignItems="center" fontSize="xs">
                                    <Icon as={FiBriefcase} mr={1} /> Hor. Comercial
                                </StatLabel>
                                <StatNumber fontSize="sm">
                                    {formatarMinutos(response_time_data.weekdays_working_hours?.response_time)}
                                </StatNumber>
                            </Stat>
                        </WrapItem>
                        <WrapItem>
                            <Stat size="xs">
                                <StatLabel display="flex" alignItems="center" fontSize="xs">
                                    <Icon as={FiMoon} mr={1} /> Hor. Extra
                                </StatLabel>
                                <StatNumber fontSize="sm">
                                    {formatarMinutos(response_time_data.weekdays_extra_hours?.response_time)}
                                </StatNumber>
                            </Stat>
                        </WrapItem>
                        <WrapItem>
                            <Stat size="xs">
                                <StatLabel display="flex" alignItems="center" fontSize="xs">
                                    <Icon as={FiSun} mr={1} /> Fim de Semana
                                </StatLabel>
                                <StatNumber fontSize="sm">
                                    {formatarMinutos(response_time_data.weekend?.response_time)}
                                </StatNumber>
                            </Stat>
                        </WrapItem>
                    </Wrap>
                </>
            ) : (
                <Text fontSize="sm" color="gray.500">
                    Dados de tempo de resposta indisponíveis.
                </Text>
            )}

        </Box>
    );
};

const MetricasPerguntas = ({ metricas, isLoading }) => {
    if (isLoading) {
        return (
            <SimpleGrid columns={{ base: 1, lg: 2, xl: 3 }} spacing={6} mb={8}>
                <Skeleton height="120px" borderRadius="lg" />
                <Skeleton height="120px" borderRadius="lg" />
                <Skeleton height="120px" borderRadius="lg" />
            </SimpleGrid>
        );
    }

    if (!metricas) return null;

    // Uma coluna por conta que veio (a conta 3 pode não vir de um servidor antigo); três lado a lado só no xl,
    // no lg o rótulo "Sem Resposta" quebraria e desalinharia os números.
    const cards = [metricas.conta_1, metricas.conta_2, metricas.conta_3].filter(Boolean).length || 1;

    return (
        <SimpleGrid columns={{ base: 1, lg: Math.min(cards, 2), xl: cards }} spacing={6} mb={2}>
            {metricas.conta_1 && <MetricaCard title="Métricas - Conta 1" data={metricas.conta_1} />}
            {metricas.conta_2 && <MetricaCard title="Métricas - Conta 2" data={metricas.conta_2} />}
            {metricas.conta_3 && <MetricaCard title="Métricas - Conta 3" data={metricas.conta_3} />}
        </SimpleGrid>
    );
};

export default MetricasPerguntas;